import styled, { css } from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const PriceElement = styled.div<{ isRowDirection?: boolean }>`
    flex-direction: column;
    align-items: flex-end;

    @media (max-width: ${wideBreakpoints.mobile}) {
        align-items: flex-start;
    }

    ${p => p.isRowDirection && css`
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
    `};
`;

export const Price = styled.div`
    white-space: nowrap;
    ${FONTS.XS};
    color: ${COLORS.TextPrimary};
`;

export const PriceText = styled.div`
    ${FONTS.XS};
    color: ${COLORS.TextSecondary};
`;
